import { useMemo } from "react";
import { useWorkspaceDetails, useWorkspacesList } from "@api/workspace.api";
import { effectiveWorkspaceRole } from "@common/helpers/effectiveWorkspaceRole";
import { canRoleEditCoa } from "@hooks/permissions/canRoleEditCoa";
import { filterCopySourceEntities } from "./lib";

interface Params {
    workspaceId?: string;
}

export function useCopySourceEntities({ workspaceId }: Params) {
    const { data: workspaceDetails, isFetched: isWorkspaceDetailsFetched } =
        useWorkspaceDetails(workspaceId);
    const { data: workspaces, isFetched: isWorkspacesFetched } =
        useWorkspacesList(
            { includeEntities: true },
            { enabled: !!workspaceId },
        );

    const workspace = workspaces?.find((item) => item.id === workspaceId);
    const role = workspace
        ? effectiveWorkspaceRole({
              storedRole: workspace.access.workspaceRole,
              plan: workspace.plan,
          })
        : null;
    const canEditCoa = role !== null && canRoleEditCoa(role);
    const isGlFirstEnabled =
        workspaceDetails?.workspace.glFirstEnabledAt != null;

    const entities = useMemo(
        () =>
            filterCopySourceEntities({
                entities: workspace?.entities ?? [],
                isGlFirstEnabled,
            }),
        [workspace, isGlFirstEnabled],
    );

    return {
        entities,
        areCopySourcesFetched:
            !workspaceId || (isWorkspaceDetailsFetched && isWorkspacesFetched),
        canEditCoa,
        isOrganizationWorkspace:
            (workspaceDetails?.organizationAssignments.length ?? 0) > 0,
    };
}
